var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgTrainerInForm(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9 18h2v1a1 1 0 11-2 0v-1zM9 1a1 1 0 112 0v1H9V1zm9 10V9h1a1 1 0 110 2h-1zM1 11a1 1 0 110-2h1v2H1zm2.707 6.707a1 1 0 01-1.414-1.414l1-1 1.414 1.414-1 1zm13-13l-1.414-1.414 1-1a1 1 0 011.414 1.414l-1 1zm-12-1.414L3.293 4.707l-1-1a1 1 0 011.414-1.414l1 1zm10.586 13.414l1.414-1.414 1 1a1 1 0 11-1.414 1.414l-1-1zM10 16a6 6 0 110-12 6 6 0 110 12z",
    fill: "#f59c00"
  })));
}
export default SvgTrainerInForm;